import z from "zod";
import { countryOfOperation, organizationSchema } from "./organizations";

const authEmployeeUserProfileSchema = z.object({
  sub: z.string(),
  employee_number: z.string(),
  given_name: z.string(),
  // The auth service names the organization claim `unit`.
  unit: organizationSchema,
});

export const employeeUserProfileSchema = z.object({
  userId: z.string(),
  employeeNumber: z.string(),
  givenName: z.string(),
  organization: organizationSchema,
  countryCode: z.enum(["SE", "CH", "LV"]),
});

export const useEmployeeUserProfile = (
  user: { profile: unknown } | null | undefined,
) => {
  if (!user) {
    throw new Error(
      "No user found. This is usually because the hook is executed outside of an AuthProvider, or because the authentication is not completed yet.",
    );
  }

  const {
    sub,
    employee_number,
    given_name,
    unit: organization,
  } = authEmployeeUserProfileSchema.parse(user.profile, {
    error: () =>
      "Incorrect user profile. Malformed or missing 'sub', 'employee_number', 'given_name' or 'unit. Did you forget the 'employee_profile' or 'organization' scopes?",
  });

  return employeeUserProfileSchema.parse({
    // The OIDC subject identifier, used to scope this employee's browser storage.
    userId: sub,
    employeeNumber: employee_number,
    givenName: given_name,
    organization,
    countryCode: countryOfOperation(organization),
  });
};
